import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Snowflake } from 'lucide-react';

const About = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-5">
              <h1 className="display-5 fw-bold mb-4 text-primary">
                <Snowflake size={28} className="me-2" style={{ color: 'var(--pm-accent)' }} />
                About PowderMaps
              </h1>
              
              <div className="mb-4">
                <h3 className="h5 fw-bold mb-3">What is PowderMaps?</h3>
                <p className="text-muted">
                  PowderMaps is your ultimate resource for tracking snowfall at ski resorts around the world. 
                  We provide real-time snow forecasts and recent snowfall data to help you plan your next 
                  powder day with confidence.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="h5 fw-bold mb-3">Features</h3>
                <ul className="text-muted">
                  <li className="mb-2">
                    <strong>Interactive Map:</strong> Browse thousands of ski resorts worldwide with 
                    real-time snow data displayed on an intuitive map interface.
                  </li>
                  <li className="mb-2">
                    <strong>Advanced Filters:</strong> Filter resorts by forecast, recent snowfall, 
                    lift count, elevation, country, and region to find your perfect destination.
                  </li>
                  <li className="mb-2">
                    <strong>Leaderboard:</strong> See the top 100 resorts ranked by snowfall—both 
                    forecasted and recent—updated in real-time.
                  </li>
                  <li className="mb-2">
                    <strong>Detailed Resort Info:</strong> View comprehensive information including 
                    elevation data, lift counts, and weather forecasts for each resort.
                  </li>
                </ul>
              </div>

              <div className="mb-4">
                <h3 className="h5 fw-bold mb-3">Data Sources</h3>
                <p className="text-muted">
                  Our snowfall data is aggregated from multiple weather services and updated regularly 
                  to provide you with the most accurate and up-to-date information available.
                </p>
              </div>

              <div className="text-center mt-5 pt-4 border-top">
                <p className="text-muted mb-0">
                  Built for skiers and snowboarders who chase powder
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default About;